// @ts-nocheck
import StoreFormWrapper from "@store/Library/Components/Foundation/StoreForm/StoreFormWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC } from "react";

interface Props extends WidgetProps {}

const FormWrapper: FC<Props> = ({ id }) => {
    return (
        <StoreFormWrapper>
            <Zone contentId={id} zoneName="Content" />
        </StoreFormWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: FormWrapper,
    definition: {
        group: "Basic",
        displayName: "Form Wrapper",
    },
};

export default widgetModule;
